import { useAuth } from '@/lib/auth/useAuth'
import { useRealtimeTopic } from '@/lib/realtime/RealtimeHub'

export function AuditRealtimeSubscriptions() {
  const { isPlatformAdmin, currentOrgSlug } = useAuth()

  useRealtimeTopic(
    {
      id: 'platform-mirror-status',
      url: '/api/admin/audit/mirrors/stream',
      invalidates: [['audit-mirrors-strip'], ['audit-mirrors']],
    },
    isPlatformAdmin,
  )

  useRealtimeTopic(
    {
      id: 'platform-audit-events',
      url: '/api/admin/audit/stream',
      invalidates: [['audit-events', 'platform']],
    },
    isPlatformAdmin,
  )

  useRealtimeTopic(
    currentOrgSlug
      ? {
          id: `org-audit-events-${currentOrgSlug}`,
          url: `/api/orgs/${encodeURIComponent(currentOrgSlug)}/admin/audit/stream`,
          invalidates: [['audit-events', 'org', currentOrgSlug]],
        }
      : null,
    !!currentOrgSlug,
  )

  return null
}
